/**
 * Maximum pending buildingBuild events per planet (all three zone queues
 * combined). Ship builds are unlimited (bounded by free population instead)
 * and scrap recycling is limited per building level instead. Science and
 * ship-upgrade queues each use their own, smaller tiers below — not these.
 */
export const QUEUE_LIMITS = {
    normal: 5,
    premium: 7,
    platinum: 10,
};
export function getQueueLimit(tier) {
    return QUEUE_LIMITS[tier ?? "normal"];
}
/**
 * Which tiers get the one-click "Queue max" building action (issue #219):
 * it queues as many consecutive levels of one building as fit at once. Each
 * level still takes its own slot under {@link QUEUE_LIMITS}, so the perk is
 * a convenience, not extra capacity.
 */
export const MULTI_LEVEL_QUEUE_ACCESS = {
    normal: false,
    premium: false,
    platinum: true,
};
export function canQueueMultipleLevels(tier) {
    return MULTI_LEVEL_QUEUE_ACCESS[tier ?? "normal"];
}
/**
 * Maximum pending scienceResearch events on the player's profile (single
 * global queue, not per-planet). Per `docs/game-details/sciences.md`:
 * "Queue: up to 3 slots (5 Premium, 6 Platinum)" — distinct from
 * {@link QUEUE_LIMITS}, which is calibrated for the building queue.
 */
export const RESEARCH_QUEUE_LIMITS = {
    normal: 3,
    premium: 5,
    platinum: 6,
};
export function getResearchQueueLimit(tier) {
    return RESEARCH_QUEUE_LIMITS[tier ?? "normal"];
}
/**
 * Maximum pending shipUpgrade events on the player's profile (single global
 * queue, not per-planet — same shape as {@link RESEARCH_QUEUE_LIMITS}). Per
 * `docs/game-details/ship-upgrades.md` / issue #23: "Upgrades queue: up to
 * 3 slots (5 Premium, 6 Platinum)". Numerically identical to the research
 * tiers today, but kept as its own table since the two queues are unrelated
 * and each is free to change independently.
 */
export const SHIP_UPGRADE_QUEUE_LIMITS = {
    normal: 3,
    premium: 5,
    platinum: 6,
};
export function getShipUpgradeQueueLimit(tier) {
    return SHIP_UPGRADE_QUEUE_LIMITS[tier ?? "normal"];
}
//# sourceMappingURL=queue.js.map